import "@blocknote/mantine/style.css";

import { BiUndo, BiRedo, BiSync } from "react-icons/bi";
import { PiDownloadSimpleBold } from "react-icons/pi";
import { HiOutlineChatAlt2 } from "react-icons/hi";

import {
  BasicTextStyleButton,
  BlockTypeSelect,
  ColorStyleButton,
  CreateLinkButton,
  useBlockNoteEditor,
  // ImageCaptionButton,
  NestBlockButton,
  TextAlignButton,
  UnnestBlockButton,
  useComponentsContext,
} from "@blocknote/react";
import { useUiStore } from "@/stores/UiStore";

export default function EditorToolbar({
  isSaving,
  convertMarkdowntoWord,
  lastSaved,
  isEditable = true,
}) {
  const editor = useBlockNoteEditor();
  const sidebarExpanded = useUiStore((state) => state.sidebarExpanded);

  const Components = useComponentsContext();

  const toggleChat = async () => {
    // check if assistant already created for this contract and user
    useUiStore.setState((state) => ({
      wideLayout: !state.wideLayout,
      sidebarExpanded: false,
    }));
  };

  return (
    <div
      className={`bn-toolbar bn-toolbar-custom  !gap-2 !items-center !justify-center !top-0 !h-10  !border-l-0   !border-b-[var(--gray-200)]  !rounded-none !fixed !shadow-none  !bg-[var(--gray-50)] !z-10 ${
        sidebarExpanded
          ? "!w-[calc(100%-18rem)] !left-[18rem] "
          : "!w-[calc(100%-5rem)] !left-[5rem]"
      } `}
    >
      <div className="!flex !flex-wrap justify-between">
        <div className="ml-8 flex text-xs items-center justify-center gap-2 ">
          <BiSync className={`w-4 h-auto ${isSaving ? "animate-spin" : ""} `} />
          {isSaving ? (
            <span className="text-muted-foreground">Saving </span>
          ) : (
            lastSaved && (
              <span className="text-muted-foreground">
                Last saved: {lastSaved}
              </span>
            )
          )}
        </div>
        {isEditable && (
          <div className="flex !bg-[var(--gray-50)] items-center justify-center gap-4">
            <Components.FormattingToolbar.Button
              mainTooltip={"Undo"}
              onClick={() => {
                editor._tiptapEditor.chain().focus().undo().run();
              }}
              // isSelected={isSelected}
              isDisabled={!isEditable}
              icon={<BiUndo />}
            />

            <Components.FormattingToolbar.Button
              mainTooltip={"Redo"}
              onClick={() => {
                editor._tiptapEditor.chain().focus().redo().run();
              }}
              // isSelected={isSelected}
              isDisabled={!isEditable}
              icon={<BiRedo />}
            />

            <BlockTypeSelect key={"blockTypeSelect"} />

            <BasicTextStyleButton
              basicTextStyle={"bold"}
              key={"boldStyleButton"}
            />
            <BasicTextStyleButton
              basicTextStyle={"italic"}
              key={"italicStyleButton"}
            />
            <BasicTextStyleButton
              basicTextStyle={"underline"}
              key={"underlineStyleButton"}
            />
            <BasicTextStyleButton
              basicTextStyle={"strike"}
              key={"strikeStyleButton"}
            />
            <BasicTextStyleButton
              key={"codeStyleButton"}
              basicTextStyle={"code"}
            />

            <TextAlignButton
              textAlignment={"left"}
              key={"textAlignLeftButton"}
            />
            <TextAlignButton
              textAlignment={"center"}
              key={"textAlignCenterButton"}
            />
            <TextAlignButton
              textAlignment={"right"}
              key={"textAlignRightButton"}
            />

            <ColorStyleButton key={"colorStyleButton"} />

            <NestBlockButton key={"nestBlockButton"} />
            <UnnestBlockButton key={"unnestBlockButton"} />

            <CreateLinkButton key={"createLinkButton"} />
          </div>
        )}

        <div className="!bg-[var(--gray-50)] flex mr-8 gap-8 items-center justify-center">
          <Components.FormattingToolbar.Button
            mainTooltip={
              "Chat with this proposal to edit, summarize, expand, or ask questions effortlessly."
            }
            onClick={toggleChat}
            className="w-6 h-6 mx-4 rounded"
          >
            <HiOutlineChatAlt2 className="mr-2" />
            Chat with Proposal
          </Components.FormattingToolbar.Button>

          <Components.FormattingToolbar.Button
            mainTooltip={"Download as a Word document"}
            onClick={convertMarkdowntoWord}
            className="w-6 h-6 mx-4 rounded"
          >
            <PiDownloadSimpleBold className="mr-2" />
            Download
          </Components.FormattingToolbar.Button>
        </div>
      </div>
    </div>
  );
}
